module.exports = __webpack_public_path__ + "img/can.6c2a5975.svg";